import type { LessonMeta } from '../../Lesson/types';

export type TabSpecies = 'dog' | 'cat';

export interface CategoryOption { value: string; label: string; count: number }

// 'both' lessons (e.g. Enrichment) show under Dogs and Cats alike — QA 1.4.
export function forSpecies(lessons: LessonMeta[], species: TabSpecies): LessonMeta[] {
  return lessons.filter((l) => l.species === species || l.species === 'both');
}

export function categoryOptions(lessons: LessonMeta[], species: TabSpecies): CategoryOption[] {
  const scoped = forSpecies(lessons, species);
  const counts = new Map<string, number>();
  scoped.forEach((l) => counts.set(l.category, (counts.get(l.category) || 0) + 1));

  const noun = species === 'dog' ? 'Dog' : 'Cat';
  const all: CategoryOption = {
    value: 'all',
    label: `All ${noun} Lessons (${scoped.length})`,
    count: scoped.length,
  };
  const rest = [...counts.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([category, count]) => ({ value: category, label: `${category} (${count})`, count }));

  return [all, ...rest];
}

// Title + summary + category. `keywords` is named in the ticket's search
// contract but only 1 of 96 lessons has any, so it is deliberately not part of
// the match — see the open content items in tools/lesson-extract/FIDELITY.md.
export function searchLessons(lessons: LessonMeta[], query: string): LessonMeta[] {
  const q = query.trim().toLowerCase();
  if (!q) return lessons;
  return lessons.filter((l) => `${l.title} ${l.summary} ${l.cardSummary} ${l.category}`
    .toLowerCase()
    .includes(q));
}

export function paginate<T>(items: T[], page: number, pageSize: number): T[] {
  const start = (page - 1) * pageSize;
  return items.slice(start, start + pageSize);
}
